<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Course` : "Add Course" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12"
            ><v-text-field
              v-model.trim="form.name"
              label="Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.code"
              label="Code*"
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
              @input="form.code = form.code.toUpperCase()"
          /></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.sub_type"
              :items="subTypes"
              item-text="name"
              item-value="id"
              label="Sub type*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.department_id"
              :items="departments"
              item-text="name"
              item-value="id"
              label="Department"
              outlined
              dense
              :readonly="prefilled_department"
              :append-icon="prefilled_department ? '' : 'mdi-menu-down'"
              hide-details="auto"
            ></v-autocomplete
          ></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    departments: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    department_id: {
      type: Number,
      default: () => null,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        department_id: null,
      },
      prefilled_department: false,
      subTypes: [
        { id: "Theory", name: "Theory" },
        { id: "Lab", name: "Lab" },
        { id: "ST&SP", name: "ST&SP" },
        { id: "ST&SL", name: "ST&SL" },
        { id: "Project", name: "Project" },
      ],
    };
  },
  computed: {},
  created() {
    this.init();
    if (this.department_id) {
      this.prefilled_department = true;
      this.form.department_id = this.departments.find(
        (x) => x.id == this.department_id
      )?.id;
    }
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.course };
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
